/** Interne Verlinkung der SEO-Einstiegsseiten (verwandt + beliebt). */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";

export const SeoLinkList = ({ title, subtitle, links, testid }) => {
  if (!links || links.length === 0) return null;
  return (
    <section className="space-y-2" data-testid={testid}>
      <h2 className="text-base font-semibold text-zinc-200 md:text-lg">{title}</h2>
      {subtitle && <p className="text-sm text-zinc-500">{subtitle}</p>}
      <div className="flex flex-wrap gap-2">
        {links.map((l) => (
          <Link
            key={`${l.lang}-${l.path}`}
            to={l.path}
            hrefLang={l.lang}
            data-testid={`seo-link-${l.page.key}`}
            className="inline-flex items-center gap-1.5 rounded-xl border border-zinc-800 bg-zinc-900/50 px-3 py-2 text-xs text-zinc-300 transition-colors hover:border-emerald-500/60 hover:text-emerald-300"
          >
            {l.label}
            <ArrowUpRight size={11} className="text-zinc-600" aria-hidden />
          </Link>
        ))}
      </div>
    </section>
  );
};

/** Kuratierte Einstiege für Home/Footer. */
export const PopularSearches = ({ links }) => {
  const { t } = useTranslation(["seo"]);
  return (
    <SeoLinkList
      title={t("seo:popular.title")}
      subtitle={t("seo:popular.subtitle")}
      links={links}
      testid="seo-popular-searches"
    />
  );
};

export default SeoLinkList;
